module.exports = __webpack_public_path__ + "img/pic_number_80.bc872fd9.png";